
export enum CanvasEventType {
  LOGO_CIRCLE_ANIMATION_IN = 'logo-circle-animation-in'
}
